import { AsteriskNotification } from "Components/AsteriskNotification";
import { BulmaNavButtons } from "Components/BulmaNavButtons";
import { Heading } from "Components/Heading";
import { useDocumentTitle, useFieldProps } from "Components/Hooks";
import { Horizontal } from "Components/Horizontal";
import { Radio, RadioYesNoBool } from "Inputs/Radio";
import { Textarea } from "Inputs/Textarea";
import { Textbox } from "Inputs/Textbox";
import { Program } from "SharedConstants";
import { FitnessInstructorAccreditationModel } from "SharedConstants/Schema";
import { MVCForm, MVCFormServerProps } from "Views/MVCForm";
import { ModelStateValues } from "Views/Tools";
import { AccreditationInput } from "./AccreditationInput";

export function AccreditationAndFacilities(
  props: FitnessInstructorAccreditationModel & {
    formProps: MVCFormServerProps;

    AccreditationOrganizationDropdownList: string[];
  },
) {
  const getInitialValues = (values: ModelStateValues) => {
    return {
      ...values,
      FitnessInstructorAccreditationOrganization: values.OtherAccreditationOrganization
        ? props.OtherOrganizationDropdownName
        : props.AccreditationOrganizationDropdownList.find(e => {
            const selected = values.FitnessInstructorAccreditationOrganization;
            return e && selected && e.toLowerCase() === selected.toLowerCase();
          }),
      HasMinimumHoursForOtherAccOrg: !!values.OtherAccreditationOrganization,
    };
  };
  const isSup = props.Program === Program.Sup;

  const title = `${
    !props.IsDanceFitnessProducer ? "Accreditation" : "Requirements"
  } and Facilities`;
  useDocumentTitle(`${title} - ${props.TitleProps.PageTitleSuffix}`);
  return (
    <>
      <Heading {...props} title={title} />
      <MVCForm
        encType="multipart/form-data"
        {...props.formProps}
        initialValues={getInitialValues(props.formProps.initialValues)}
        initialErrors={{
          ...props.formProps.initialErrors,
          CertificateFile:
            props.formProps.initialErrors["Certificate_Upload"] || [],
        }}
      >
        {({ values, isSubmitting }) => (
          <div className="narrowFieldBodies2">
            <AsteriskNotification>
              {!isSup && (
                <>
                  {" "}
                  Please note that we can only accept licenses from the listed
                  accredited personal training certifications or one with 200+
                  hours of training. Any other certifications will need to use
                  the non-certified rate.
                </>
              )}
            </AsteriskNotification>
            {props.ShowAccreditationFields && (
              <AccreditationInput
                options={props.AccreditationOrganizationDropdownList}
                otherOption={props.OtherOrganizationDropdownName}
                values={values}
                validFileTypes={props.ValidUploadMimeTypes}
                certificateFilename={props.CertificateFilename || undefined}
                isSup={isSup}
                hasOpenWaterCoverage={props.HasOpenWaterCoverage}
              />
            )}
            {isSup && <SupiaInput />}
            <Horizontal isRequired label={isSup ? "Locations" : "Facilities"}>
              <Textarea
                fieldName="LocationOfTraining"
                placeholder="Location(s) of Training"
              />
            </Horizontal>
            {!isSup && (
              <Horizontal
                isRequired
                label="Liability Insurance"
                shouldNotPadLabel
              >
                <Radio
                  fieldName="DoesFacilityHaveLiabilityInsurance"
                  options={[
                    ["Yes", "Yes"],
                    ["No", "No"],
                    ["Other", "Unknown"],
                  ]}
                >
                  <div>
                    Does the Facility or Facilities carry Liability Insurance?
                  </div>
                </Radio>
              </Horizontal>
            )}
            <BulmaNavButtons
              backCaption="Back"
              continueCaption="Continue"
              isDisabled={isSubmitting}
            />
          </div>
        )}
      </MVCForm>
    </>
  );
}

function SupiaInput() {
  const isSupiaMemberField = useFieldProps("IsSupiaMember");
  return (
    <>
      <Horizontal isRequired label="SUPIA Membership" shouldNotPadLabel>
        <RadioYesNoBool fieldName={isSupiaMemberField.name}>
          <div>
            <span className="has-text-weight-bold">
              Are you a member of the Stand Up Paddle Industry Association?
            </span>{" "}
            (10% Discount on Premium)
          </div>
        </RadioYesNoBool>
      </Horizontal>
      {isSupiaMemberField.value === "true" && (
        <Horizontal isRequired label="SUPIA ID">
          <Textbox
            fieldName="SupiaIDNumber"
            placeholder="5- or 6-digit SUPIA ID Number"
          />
        </Horizontal>
      )}
    </>
  );
}
